import { Box, useMantineTheme } from "@mantine/core";
import { useAtomValue } from "jotai";

import Flex from "components/Flex";
import Text from "components/Text";
import { POINT_OF_IMPACT_TRANSLATION_KEYS } from "components/VehicleImpact/constants";

import { pointsOfImpactOrderedListAtom } from "atoms/pointsOfImpact";
import { useClientTranslation } from "hooks/useClientTranslation";

import { PointOfImpact } from "./types";

export const PointOfImpactList = () => {
  const orderedList = useAtomValue(pointsOfImpactOrderedListAtom);
  const theme = useMantineTheme();

  const { t } = useClientTranslation();

  return (
    <>
      {!orderedList.length && <Text sizeVariant="md">{t("damage_area.instruction")}</Text>}
      {Boolean(orderedList.length) && (
        <Flex component="ul" direction="row" gap={8} align="flex-start" style={{ flexWrap: "wrap" }}>
          {orderedList.map((pointOfImpact) => (
            <Box
              key={pointOfImpact}
              px={8}
              component="li"
              py={2}
              style={{
                background: theme.other.primary[5],
                borderRadius: "16px",
              }}
            >
              <Text weight={500} color={theme.other.primary[80]}>
                {t(POINT_OF_IMPACT_TRANSLATION_KEYS[pointOfImpact as PointOfImpact])}
              </Text>
            </Box>
          ))}
        </Flex>
      )}
    </>
  );
};
